"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParserAPIVersion = void 0;
// https://github.com/asyncapi/parser-api/releases/tag/v3.0.0
exports.ParserAPIVersion = 3;
